import React, { useEffect } from 'react';

import { isSafari } from 'react-device-detect';
import Container from 'react-bootstrap/Container';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Menu from '../../components/Menu';
import Footer from '../../components/Footer';
import AuthGuard from '../../components/AuthGuard';

const Home = () => {
  document.title = 'Datamais - Administrador';
  useEffect(() => {
    if (isSafari) {
      toast.warning('Não recomendamos o uso do navegador Safari nesta aplicação!', {
        autoClose: 5000
      });
    }
  }, []);

  return (
    <>
      <AuthGuard />
      <Container>
        <Menu />
      </Container>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default Home;
